import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminAppUpdate(props) {
    const [app_version, setApp_version] = useState({
        local_iot: '',
        local_api: '',
        local_ui: '',
        password: ''
    });

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {

    }

    async function api_update_app(topic, versionx) {
        setmodal_load({ enable: true, message: "Sending app update command to center server." })
        await sleep(500)

        const formData = new FormData()
        formData.append('topic', topic)
        formData.append('version', versionx)
        formData.append('password', app_version.password)

        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/setting/app/update", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: response.data.message,
                        enable: true
                    });
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                });
            });
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-th-large"></i> App Update</h4>
                                    <p className="mb-0">Manage all local app update function</p>
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                            <div className="d-block mt-2" style={{ width: "160px" }}>
                                <div className="form-group">
                                    <label htmlFor="billing_address">Local API Version</label>
                                    <input type="text" className="form-control" name="billing_address" value={app_version.local_api} onChange={(e) => {
                                        setApp_version({
                                            ...app_version,
                                            local_api: e.target.value
                                        })
                                    }} required />
                                </div>
                                <button className="btn btn-danger btn-sm fw-600 font-sarabun mt-2" onClick={() => { api_update_app("update_local_api", app_version.local_api) }}>Update Local API</button>
                            </div>
                            <div className="d-block mt-2" style={{ width: "160px" }}>
                                <div className="form-group">
                                    <label htmlFor="billing_address">Local UI Version</label>
                                    <input type="text" className="form-control" name="billing_address" value={app_version.local_ui} onChange={(e) => {
                                        setApp_version({
                                            ...app_version,
                                            local_ui: e.target.value
                                        })
                                    }} required />
                                </div>
                                <button className="btn btn-danger btn-sm fw-600 font-sarabun mt-2" onClick={() => { api_update_app("update_local_ui", app_version.local_ui) }}>Update Local UI</button>
                            </div>
                            <div className="d-block mt-2" style={{ width: "160px" }}>
                                <div className="form-group">
                                    <label htmlFor="billing_address">Local IOT Version</label>
                                    <input type="text" className="form-control" name="billing_address" value={app_version.local_iot} onChange={(e) => {
                                        setApp_version({
                                            ...app_version,
                                            local_iot: e.target.value
                                        })
                                    }} required />
                                </div>
                                <button className="btn btn-danger btn-sm fw-600 font-sarabun mt-2" onClick={() => { api_update_app("update_local_iot", app_version.local_iot) }}>Update Local IOT</button>
                            </div>
                            <div className="d-block mt-2" style={{ width: "160px" }}>
                                <div className="form-group">
                                    <label htmlFor="billing_address" className=' text-danger'>Password Required !!</label>
                                    <input type="password" className="form-control" name="billing_address" value={app_version.password} onChange={(e) => {
                                        setApp_version({
                                            ...app_version,
                                            password: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminAppUpdate